export default __webpack_public_path__ + "static/media/bag_video.4f509887.mp4";